export const RESUME = {
  file_name: '.pdf, .doc, .docx, .txt',
  required: true,
};

export const REFERENCES = {
  file_name: '.pdf',
  required: false,
};

export const CERTIFICATIONS = {
  file_name: '.pdf, .doc, .docx, .zip',
  required: false,
};

export const COVER_LETTER = {
  file_name: '.pdf, .doc, .docx, .txt',
  required: false,
};

export const PROFILE_PICTURE = {
  file_name: '.jpg, .jpeg, .png',
  required: false,
};

export const PORTFOLIO = {
  file_name: '.pdf, .doc, .docx, .jpg, .jpeg, .svg, .png, .txt',
  required: false,
};

export const OTHERS = {
  file_name: '.pdf, .doc, .docx, .jpg, .jpeg, .svg, .png, .txt',
  required: false,
};
